import { render } from "./Firmwares.vue?vue&type=template&id=deef31e8"
import script from "./Firmwares.vue?vue&type=script&lang=js"
export * from "./Firmwares.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__